function doGeneralAccordion() {
  if (customElements.get("general-accordion")) return null

  class GeneralAccordion extends HTMLElement {
    constructor() {
      super()
      this.accordionHeader = this.querySelector(".generalAccordion-header")
      this.accordionBody = this.querySelector(".generalAccordion-body")
      this.iconPlus = this.querySelector(".icon-plus")
      this.iconMinus = this.querySelector(".icon-minus")
      this.closeOthers = Boolean(
        this.dataset.closeOthers && this.dataset.closeOthers == "true"
      )
      this.init()
    }

    init() {
      this.accordionHeader.addEventListener("click", () => {
        if (this.dataset.status == "0") {
          this.closeAllAccordions()
          this.toggleAccordion("show")
          return
        }

        this.toggleAccordion("hide")
      })

      if (this.dataset.status == "1") {
        this.toggleAccordion("show")
      }
    }

    /**
     * Closes absolutely all accordion on the dom
     * @returns voide
     */
    closeAllAccordions() {
      const allAccordionElements = document.querySelectorAll(
        ".snippet-generalAccordion"
      )
      if (allAccordionElements == null) return null
      allAccordionElements.forEach((accordion) =>
        accordion.setAttribute("data-status", 0)
      )
    }

    toggleAccordion(action) {
      if (action === "hide") {
        this.setAttribute("data-status", 0)
        this.accordionBody.classList.remove("open")
        return
      }

      this.setAttribute("data-status", 1)
      this.accordionBody.classList.add("open")
      return
    }
  }

  customElements.define("general-accordion", GeneralAccordion)
}

doGeneralAccordion()
